// Response shapes for /articles/:slug/reactions.
//
// All three routes (GET / POST / DELETE) return the same envelope —
// the SPA can call any of them and replace its local state with the
// returned object without a separate refetch.
import { z } from 'zod';
import { ArticleReactionState } from './reaction.js';
export const ReactionStateResponse = z.object({
    state: ArticleReactionState,
});
//# sourceMappingURL=responses.js.map